import React from 'react';
import { Title } from '@gerdau/hefesto/Title';
import { RcFile } from 'antd/es/upload/interface';
import { Container, Subtitle, UploadAreaContainer } from './styles';
import UploadArea from '../../../../../../components/UploadArea/Facelift';

interface IUploadProjectsContainer {
  handleOnFileListChange: (files: RcFile[], isNewProject?: boolean) => void;
}

const UploadProjectsContainer: React.FC<IUploadProjectsContainer> = ({
  handleOnFileListChange
}) => {
  return (
    <Container>
      <Title level={2}>Arquivos de projetos</Title>
      <Subtitle>
        Para armazenar os arquivos dos projetos, você pode enviá-los nesta área
        ou atualizá-los na tabela abaixo
      </Subtitle>
      <UploadAreaContainer data-testid="new-upload-container">
        <UploadArea
          acceptedFiles={['.dxf, .dwg, .pdf']}
          disabled={false}
          loading={false}
          onFileListChange={(files: RcFile[]) =>
            handleOnFileListChange(files, true)
          }
          acceptMultipleFiles={true}
          title={'Enviar novo projeto'}
          subtitle={`Para armazenar os arquivos dos projetos, você pode enviá-los nesta área, em .dwg, .dxf ou .pdf (preferencialmente em .dwg ou .dxf)`}
          hideChips
        />

        <UploadArea
          acceptedFiles={['.dxf, .dwg, .pdf']}
          disabled={false}
          loading={false}
          onFileListChange={(files: RcFile[]) => handleOnFileListChange(files)}
          acceptMultipleFiles={false}
          title={'Enviar revisão do projeto'}
          subtitle={`Para armazenar os arquivos dos projetos, você pode enviá-los nesta área, em .dwg, .dxf ou .pdf (preferencialmente em .dwg ou .dxf)`}
          hideChips
        />
      </UploadAreaContainer>
    </Container>
  );
};

export default UploadProjectsContainer;
